import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';
import CheckItemTextListWithActions from 'src/app/molecules/CheckItemTextList/CheckItemTextListWithActions';

const BrandedAppsImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "6HfDOwwjKeohK1viixKJlj" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  return (
    <Stack
      padding={['spacing-none', 'spacing-xl']}
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'Branded App',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='left'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingText
              maxWidth='width-2xl'
              gap='spacing-3xl'
              heading={{
                type: 'heading',
                text: 'Your own branded apps',
                size: '2xl',
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: 'Mighty Pro',
                size: 'xl',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              subHeadingGap='spacing-lg'
              supportingText={{
                type: 'paragraph',
                text: 'Never migrate again. Choose the platform that sets a clear path for growth with 90%+ retention and engagement.',
                size: 'xl',
                color: 'text-tertiary',
              }}
            />
            <CheckItemTextListWithActions
              direction='column'
              justify='flex-start'
              align='flex-start'
              checkItemTextListProps={{
                checkItems: [
                  'High-Ticket Courses & Challenges',
                  'Premium Paid Memberships',
                  'Branded iOS and Android Apps',
                ],
                checkItemProps: {
                  size: 'md',
                  type: 'default',
                  color: 'primary',
                },
              }}
              actions={
                <Stack>
                  <Button
                    variant='primary'
                    size='xl'
                    href='/pro'
                  >
                    See the Possibilities
                  </Button>
                </Stack>
              }
            />
          </Stack>
        }
      />
    </Stack>
  );
};

export default BrandedAppsImageAndContent;
